<template>
  <v-toolbar
    app="app"
    flat="flat"
    clipped-right="clipped-right"
    color="#3A3A3A"
    dark="dark"
    fixed="fixed"
    height="58"
    extension-height="48"
    ref="toolbar"
    id="app-toolbar"
  >
    <v-toolbar-side-icon
      @click.stop="drawerToggle"
      v-show="!stateless"
    ></v-toolbar-side-icon>
    <v-toolbar-title>
      <v-layout
        align-center="align-center"
        justify-center="justify-center"
        row="row"
        fill-height="fill-height"
      >
        <v-menu bottom="bottom" left="left" offset-y="offset-y">
          <v-btn dark="dark" slot="activator" icon="icon">
            <v-icon>{{ selectedSearchType.icon }}</v-icon>
          </v-btn>
          <v-list class="menu-button">
            <v-list-tile
              v-for="(item, i) in items"
              :key="i"
              @click="selectSelected(item)"
              avatar="avatar"
            >
              <v-list-tile-avatar>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-text-field
          label="Search"
          color="white"
          v-model="search"
          @keyup.enter="searchText"
          solo-inverted="solo-inverted"
          flat="flat"
          text-color="white"
          hide-details="hide-details"
          single-line="single-line"
        ></v-text-field>
      </v-layout>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <Notifications></Notifications>
    <UserMenu></UserMenu>
  </v-toolbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Notifications from './Notifications';
import locationService from '../../Location/service.js';
import UserMenu from './Menu';

export default {
  data() {
    return {
      menu: false,
      selectedSearchType: {
        icon: 'mdi-store',
        title: 'Store',
      },
      items: [
        { title: 'Store', icon: 'mdi-store' },
        { title: 'Organization', icon: 'business' },
        { title: 'Lead', icon: 'filter_list' },
        { title: 'Ticket', icon: 'local_offer' },
        { title: 'Contact', icon: 'contacts' },
      ],
      stateless: false,
      search: null,
    };
  },
  components: {
    Notifications,
    UserMenu,
  },
  methods: {
    ...mapActions('global', ['setSearch']),
    ...mapActions('layout', ['drawerToggle']),
    selectSelected(val) {
      this.selectedSearchType = val;
    },
    searchLocation(val) {
      this.$Progress.start();
      switch (this.search.substring(0, 3).toLowerCase()) {
        case 'csp':
          locationService
            .getbyCspID(this.search)
            .then((result) => {
              console.log('result', result);
              if (Object.keys(result.data).length !== 0) {
                this.search = null;
                this.$router.push({
                  path: `/location/profile/${result.data.storeID}`,
                });
              } else {
                this.$swal(this.search, 'Was not found', 'error').then(() => {
                  this.search = null;
                });
              }
            })
            .catch((err) => {
              console.log('err', err);
              this.$swal(this.search, 'Was not found', 'error').then(() => {
                this.search = null;
              });
            });
          break;
        case 'id=':
          this.$router.push({
            path: `/location/profile/${this.search
              .substring(3, this.search.length)
              .toLowerCase()}`,
          });
          this.search = null;
          break;

        default:
          this.setSearch(this.search);
          this.search = null;
          this.$router.push({ name: 'search-location' });
          break;
      }
      this.$Progress.finish();
    },
    searchLead(val) {
      this.$Progress.start();
      if (this.search.substring(0, 3).toLowerCase() === 'id=') {
        this.$router.push({
          path: `/leads/profile/${this.search
            .substring(3, this.search.length)
            .toLowerCase()}`,
        });
        this.search = null;
      } else {
        this.setSearch(this.search);
        this.search = null;
        this.$router.push({ name: 'search-lead' });
      }
      this.$Progress.finish();
    },
    searchTicket(val) {
      this.$Progress.start();
      if (this.search.substring(0, 3).toLowerCase() === 'id=') {
        this.$router.push({
          path: `/tickets/profile/${this.search
            .substring(3, this.search.length)
            .toLowerCase()}`,
        });
        this.search = null;
      } else {
        this.setSearch(this.search);
        this.search = null;
        this.$router.push({ name: 'search-ticket' });
      }
      this.$Progress.finish();
    },
    searchContact(val) {
      this.$Progress.start();
      this.setSearch(this.search);
      this.search = null;
      this.$router.push({ name: 'search-contact' });
      this.$Progress.finish();
    },
    searchOrganization(val) {
      this.$Progress.start();
      if (this.search.substring(0, 3).toLowerCase() === 'id=') {
        this.$router.push({
          path: `/organization/profile/${this.search
            .substring(3, this.search.length)
            .toLowerCase()}`,
        });
        this.search = null;
      } else {
        this.setSearch(this.search);
        this.search = null;
        this.$router.push({ name: 'search-organization' });
      }
      this.$Progress.finish();
    },
    searchText(val) {
      if (this.selectedSearchType.title === 'Store') this.searchLocation(val);
      if (this.selectedSearchType.title === 'Lead') this.searchLead(val);
      if (this.selectedSearchType.title === 'Ticket') this.searchTicket(val);
      if (this.selectedSearchType.title === 'Organization') { this.searchOrganization(val); }
      if (this.selectedSearchType.title === 'Contact') this.searchContact(val);
    },
  },
  computed: {
    ...mapGetters('global', ['currentOrganization']),
  },
};
</script>
